module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9t7bQ"))).then(() => parcelRequire('2KbAe'));